<template>
  <div>
    <img
        :src="icon"
        class="account-verification__step__icon"
        :class="additionalCustomIconStyles">

    <h1 class="account-verification__step__title">
      {{ title }}
    </h1>

    <p class="account-verification__step__description">
      {{ description }}
    </p>

    <p class="account-verification__step__description account-verification__step__data">
      {{ confirmationData }}
    </p>

    <input
        ref="passcodeTxt"
        v-model="passcode"
        type="text"
        class="passcode"
        :class="additionalPasscodeInputStyles"
        maxlength="6"
        spellcheck="false">
  </div>
</template>

<script>
const CONTAINS_ONLY_DIGITS_REGEX = /^[0-9]+$/;

export default {
  name: "PasscodeReader",
  props: {
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    confirmationData: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    isMarkedAsError: {
      type: Boolean,
      default: false,
    },
  },
  inject: ["VERIFICATION_METHODS_MAP"],
  emits: ["errorNotification", "validPasscode"],
  data() {
    return {
      passcode: "",
    };
  },
  computed: {
    additionalCustomIconStyles() {
      switch (this.verificationMethodType) {
        case this.VERIFICATION_METHODS_MAP.EMAIL:
          return "account-verification__step__custom-email-icon";
        default:
          return "";
      }
    },
    additionalPasscodeInputStyles() {
      let additionalStyles = [];
      if (!this.passcode || this.passcode.length < 6) {
        additionalStyles.push("passcode-underline");
      }

      if (this.passcode && !CONTAINS_ONLY_DIGITS_REGEX.test(this.passcode)) {
        additionalStyles.push("passcode-error");
        additionalStyles.push("passcode-underline-error");
      }

      if (this.isMarkedAsError) {
        additionalStyles.push("passcode-error");
        this.$refs.passcodeTxt.focus();
      }

      return additionalStyles.join(" ");
    },
  },
  watch: {
    passcode() {
      // Cleaning errors
      this.$emit("errorNotification", null);

      if (!this.passcode) {
        return;
      }

      if (!CONTAINS_ONLY_DIGITS_REGEX.test(this.passcode)) {
        this.$emit(
          "errorNotification",
          "Passcodes can only contain numbers. Please try again."
        );
        return;
      }

      let isValidPasscode = this.passcode.length === 6;
      if (isValidPasscode) {
        this.$emit("validPasscode", this.passcode);
      }
    },
  },
  mounted() {
    this.$refs.passcodeTxt.focus();
  },
};
</script>

<style  lang="scss" scoped>
$char-w: 1ch;
$gap: 0.5 * $char-w;
$n-char: 6;
$in-w: $n-char * ($char-w + $gap);

.passcode {
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 42px;
  color: #1998d5;
  display: block;
  border: none;
  padding: 0;
  width: $in-w;
  letter-spacing: $gap;
  outline: none;
}

.passcode-underline {
  background: repeating-linear-gradient(
      90deg,
      #1998d5 0,
      #1998d5 $char-w,
      transparent 0,
      transparent $char-w + $gap
    )
    0 100% / #{$in-w - $gap} 2px no-repeat;
}

.passcode-error {
  color: #d4231a;
}

.passcode-underline-error {
  background: repeating-linear-gradient(
      90deg,
      #d4231a 0,
      #d4231a $char-w,
      transparent 0,
      transparent $char-w + $gap
    )
    0 100% / #{$in-w - $gap} 2px no-repeat;
}
</style>
